var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgElIconYoutubeBrand = function SvgElIconYoutubeBrand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#el-icon-youtube-brand_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1.167 2.917h11.667v8.167H1.167z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "m6.037 8.094 2.45-1.269-2.45-1.312v2.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M10.85 0h-7.7C1.4 0 0 1.4 0 3.15v7.7C0 12.6 1.4 14 3.15 14h7.7C12.6 14 14 12.6 14 10.85v-7.7C14 1.4 12.6 0 10.85 0Zm.656 7.263c0 .743-.087 1.487-.087 1.487s-.088.613-.35.919c-.35.35-.744.35-.919.393-1.269.088-3.194.088-3.194.088s-2.362 0-3.106-.088c-.219-.043-.656-.043-1.006-.393-.263-.263-.35-.919-.35-.919s-.088-.744-.088-1.487v-.7c0-.744.088-1.488.088-1.488s.131-.612.393-.875c.35-.35.744-.35.92-.394C5.074 3.72 7 3.72 7 3.72s1.925 0 3.194.087c.175 0 .568.044.918.394.263.263.35.919.35.919s.088.744.088 1.487v.657h-.044Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "el-icon-youtube-brand_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h14v14H0z"
  })))));
};
export default SvgElIconYoutubeBrand;